import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';
import { breakpoint } from 'src/styles/dontgiftguide.styles';

const { colors, fonts, spacing } = dggTheme;

export const root = css`
  background-color: ${colors.parisM};
`;

export const content = css`
  margin: 0 auto;
  padding: ${pxToRem(42)} ${pxToRem(spacing.md)};
  color: ${colors.neutralWhite};
  text-align: center;
  line-height: 1.3;

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(970)};
      padding: ${pxToRem(50)} ${pxToRem(spacing.md)};
    `,
  )}
`;

export const button = css`
  a {
    font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
    background-color: ${colors.mediumPurple};
    color: ${colors.neutralWhite};
    font-weight: 600;
    display: inline-block;
    margin: 0 auto;
    &:hover {
      background-color: ${colors.neutralWhite};
      color: ${colors.parisM};
    }
  }
`;

export const heading = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  font-size: ${pxToRem(24)};
  margin: 0 auto ${pxToRem(spacing.md)};
`;

export const link = css`
  display: inline-block;
  margin: 0 ${pxToRem(spacing.md)} 0 0;
`;

export const copyright = css`
  display: block;
  margin: 0 ${pxToRem(spacing.md)} ${pxToRem(spacing.base)} 0;
  font-family: ${fonts.PRIMARY_REGULAR.familyWithFallbacks};
  font-size: ${pxToRem(14)};
  line-height: 1;

  ${mediaQuery(
    { min: breakpoint },
    css`
      display: inline-block;
      margin: 0 ${pxToRem(spacing.md)} 0 0;
    `,
  )}
`;

export const promo = css`
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${mediaQuery(
    { min: breakpoint },
    css`
      flex-direction: row;
    `,
  )}
`;

export const group = css`
  padding: 0 ${pxToRem(spacing.xl)};
  margin-bottom: ${pxToRem(36)};
`;
